var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var TactonRequestQueueAbortError = /** @class */ (function (_super) {
    __extends(TactonRequestQueueAbortError, _super);
    function TactonRequestQueueAbortError() {
        var _this = _super.call(this, "Tacton request aborted") || this;
        _this.name = "TactonRequestQueueAbortError";
        return _this;
    }
    return TactonRequestQueueAbortError;
}(Error));
export { TactonRequestQueueAbortError };
var TactonRequestQueue = /** @class */ (function () {
    function TactonRequestQueue() {
        this.chain = Promise.resolve();
        this.generation = 0;
    }
    TactonRequestQueue.prototype.enqueue = function (fn) {
        var _this = this;
        var capturedGeneration = this.generation;
        var next = this.chain.then(function () {
            if (_this.generation !== capturedGeneration) {
                throw new TactonRequestQueueAbortError();
            }
            return fn();
        });
        this.chain = next.then(function () { }, function () { });
        return next;
    };
    TactonRequestQueue.prototype.reset = function () {
        this.generation++;
        this.chain = Promise.resolve();
    };
    return TactonRequestQueue;
}());
export var tactonRequestQueue = new TactonRequestQueue();
